import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {EntityLineHeader} from '../../entity/entity-line-header';
import {EntityLineService} from '../../services/entity-line-service';
import {EntityService} from '../../services/entity-service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';

import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'line-summary-dialog',
    templateUrl: './line-summary-dialog.component.html',
    styleUrls: ['./line-summary-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatDialogActions, MatButton]
})
export class LineSummaryDialogComponent {
  private readonly entityLineService = inject(EntityLineService);
  private readonly entityService = inject(EntityService);
  dialogRef = inject<MatDialogRef<LineSummaryDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  errorMessage!: string;
  private readonly loadComplete = signal<boolean>(false);
  private readonly frozen = signal<boolean>(undefined!);
  private readonly approved = signal<boolean>(undefined!);
  private appEngineerSnBypass: boolean = false;
  public entityLine: EntityLineHeader;

  constructor
  () {
    const data = this.data;

    this.entityLine = data.line as EntityLineHeader;
    this.appEngineerSnBypass = data.appEngineerSnBypass === true;
    this.entityService.getEntityByKey(this.entityLine.key).subscribe(result => {
      this.frozen.set(result.frozen);
      this.approved.set(result.approvalStatus == 'Approved');
      this.loadComplete.set(true);
    });
  }

  public preventUpdate(): boolean {
    return this.entityLine.configured || !this.loadComplete() || this.frozen() || this.approved();
  }

  public onQuantityChange(): void {
    if (this.entityLine.serialNumberRequired && this.entityLine.quantity > 1) {
      this.entityLine.serialNumber = '';
    }
  }

  public validateDataAndClose(): void {
    this.errorMessage = null!;
    if (this.entityLine.serialNumberRequired && this.entityLine.quantity > 1 && !!this.entityLine.serialNumber) {
      this.errorMessage = 'Cannot enter a serial number for a part with quantity greater than 1';
      return;
    }
    if (this.appEngineerSnBypass || !this.entityLine.serialNumberRequired || this.validateSerialNumberData()) {
      this.saveAndClose();
    }
  }

  public saveAndClose(): void {
    this.entityLineService.updateLine(this.entityLine).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  private validateSerialNumberData(): boolean {
    const regexPattern: RegExp = /^(?:\d{2}-\d{5,6}|\d{6}-\d{1,3}-\d{1,3}|\d{2}U\d{8})$/;
    if (this.entityLine.quantity > 1) {
      this.errorMessage = 'Max quantity of 1 for parts that require a serial number';
      return false;
    } else if (!regexPattern.test(this.entityLine.serialNumber)) {
      this.errorMessage = 'Please enter a valid serialnumber';
      return false;
    }
    return true;
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

  prnValue(): string {
    const currentValue: string = this.entityLine?.prn || '';
    return currentValue.replace(/^([^_]+)_FAN_/, '$1_AHY_');
  }

}
